import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionService } from '../../services/session.service';
import { PageComponent } from '../../components/page/page.component';
import { AuthenticationStatus } from '../../util/util';
import { TranslateModule } from '@ngx-translate/core';
import { LocationsComponent } from '../../components/locations/locations.component';
import { LocationsModel } from '../../components/locations/locations-model';
import { BackendService } from '../../services/backend.service';
import { InactiveLocationsModel } from '../../components/locations/inactive-locations-model';
import { TitleComponent } from 'src/app/general/components/title/title.component';

@Component({
  selector: 'app-inactive-locations-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    TranslateModule,
    TitleComponent,
    LocationsComponent
  ],
  templateUrl: './inactive-locations-page.component.html',
  styleUrls: ['./inactive-locations-page.component.css']
})
export class InactiveLocationsPageComponent implements OnInit {

  locationsModel: LocationsModel;

  constructor(
      private sessionService: SessionService,
      private backendService: BackendService) {
    this.locationsModel = new InactiveLocationsModel(this.backendService);
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }
  }
}
